import React, { FC, InputHTMLAttributes, ReactNode } from "react";

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: ReactNode;
  className?: string;
}

const InputField: FC<InputFieldProps> = ({
  icon,
  className = "",
  ...props
}) => {
  const baseClasses = [
    "w-full",
    "py-3",
    "px-4",
    "rounded-xl",
    "border",
    "border-transparent",
    "border-sleap-gray-50",
    "bg-sleap-gray-50",
    "text-base",
    "font-normal",
    "focus:outline-none",
    "text-sleap-gray-950",
    "focus:border-sleap-gray-950",
    "autofill:bg-sleap-gray-50",
    "autofill:text-sleap-gray-950",
  ].join(" ");

  return (
    <div className="relative">
      {icon && (
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
          {icon}
        </div>
      )}
      <input
        {...props}
        className={`${baseClasses} ${icon ? "pl-12" : ""} ${className}`.trim()}
      />
    </div>
  );
};

export default InputField;
